'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.isEqual = isEqual;
exports.isValid = isValid;
exports.getValue = getValue;

var _ramda = require('ramda');

var _validation = require('./validation');

/**
 * Check is two arrays are equal (same length and all elements are ===)
 */
function isEqual(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function isValid(fields, updatedObject) {
    var validatedFields = [];
    var valid = true;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var field = _step.value;

            if (!field || field.props) {
                validatedFields.push(field);
                continue;
            }
            var value = getValue(field.path, updatedObject);
            var required = typeof field.required === 'function' ? field.required(updatedObject) : field.required;
            if (required && value === '') {
                valid = false;
                validatedFields.push(Object.assign({}, field, { validationError: _validation.required }));
                continue;
            }
            var fieldValid = true;
            if (field.validations) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = Object.entries(field.validations)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _step2$value = _slicedToArray(_step2.value, 2),
                            type = _step2$value[0],
                            validation = _step2$value[1];

                        if (value && validation.validation && !validation.validation(value)) {
                            fieldValid = false;
                            validatedFields.push(Object.assign({}, field, { validationError: type }));
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                if (!fieldValid) {
                    valid = false;
                    continue;
                }
            }
            if (field.error) {
                valid = false;
            }
            if (field.validationError) {
                valid = false;
            }
            if (fieldValid) {
                validatedFields.push(field);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return { validatedFields: validatedFields, valid: valid };
}
function getValue(path, updatedObject) {
    var value = (0, _ramda.path)(path, updatedObject);
    if (value === undefined || value === null) return '';
    return value;
}
//# sourceMappingURL=helpers.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./dist/src/helpers.js
 ** module id = 277
 ** module chunks = 0
 **/